import { render, staticRenderFns } from "./OverviewGraphicBarHeader.vue?vue&type=template&id=35984b19&scoped=true"
import script from "./OverviewGraphicBarHeader.vue?vue&type=script&lang=js"
export * from "./OverviewGraphicBarHeader.vue?vue&type=script&lang=js"
import style0 from "./OverviewGraphicBarHeader.vue?vue&type=style&index=0&id=35984b19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35984b19",
  null
  
)

export default component.exports